import { useEffect, useState } from "react";
import { useAppSelector } from "../ReduxToolkit/Hooks";
import { Nullable } from "../Types/Common";

const useCCNames = () => {
  const [ccNames, setCCNames] =
    useState<Nullable<Array<{ name: string; id: number }>>>(null);

  const [toMailNames, setToMailNames] =
    useState<Nullable<Array<{ name: string; id: number }>>>(null);

  const { data: assignedManagerData } = useAppSelector(
    ({ employeeAssignedManagerDetails }) => employeeAssignedManagerDetails
  );

  useEffect(() => {
    if (assignedManagerData) {
      const {
        additional_manager: additionalManager,
        hr,
        manager,
      } = assignedManagerData.data;

      const ccArray: { name: string; id: number }[] = [];
      const toArray: { name: string; id: number }[] = [];

      // To Mail (Managers)
      if (Array.isArray(manager)) {
        manager.forEach((d) => {
          if (d.name && d.id) toArray.push({ name: d.name, id: d.id });
        });
      }

      // CC Names (HR + Additional Managers)
      if (hr?.name && hr?.id) ccArray.push({ name: hr.name, id: hr.id });

      if (Array.isArray(additionalManager)) {
        additionalManager.forEach((m) => {
          if (m?.name && m?.id) ccArray.push({ name: m.name, id: m.id });
        });
      }

      setCCNames(ccArray);
      setToMailNames(toArray);
    }
  }, [assignedManagerData]);

  const clearCCNames = () => setCCNames(null);
  const clearToMailNames = () => setToMailNames(null);

  return { toMailNames, ccNames, clearCCNames, clearToMailNames };
};

export default useCCNames;
